import { render, staticRenderFns } from "./dialogSettingStorage.vue?vue&type=template&id=4ca07c6c&scoped=true&lang=pug&"
import script from "./dialogSettingStorage.vue?vue&type=script&lang=js&"
export * from "./dialogSettingStorage.vue?vue&type=script&lang=js&"
import style0 from "./dialogSettingStorage.vue?vue&type=style&index=0&id=4ca07c6c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ca07c6c",
  null
  
)

export default component.exports